var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "share-list share-list-book" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "file-list view-content clearfix" },
        [
          _c("div", { staticClass: "fixed-line clearfix" }, [
            _c("div", { staticClass: "fixed-left" }, [
              _c("div", { staticClass: "share-message" }, [
                _c("span", { staticClass: "share-text year" }, [
                  _vm._v(_vm._s(_vm.year) + " ")
                ]),
                _vm._v(" "),
                _vm.lang === "en"
                  ? _c("span", { staticClass: "share-text detail" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.month) +
                          " " +
                          _vm._s(_vm.day) +
                          " " +
                          _vm._s(_vm.$t("share.shared") + _vm.userName) +
                          "\n          "
                      )
                    ])
                  : _vm.lang === "ru_RU"
                  ? _c("span", { staticClass: "share-text detail" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.month) +
                          " " +
                          _vm._s(_vm.day) +
                          " " +
                          _vm._s(_vm.$t("share.shared") + _vm.userName) +
                          "\n          "
                      )
                    ])
                  : _c("span", { staticClass: "share-text detail" }, [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.month) +
                          "月" +
                          _vm._s(_vm.day) +
                          "日" +
                          _vm._s(_vm.userName) +
                          "分享的文件\n          "
                      )
                    ]),
                _vm._v(" "),
                _c("div", { staticClass: "checkbox-wrapper" }, [
                  _c("div", {
                    staticClass: "checkbox",
                    class: { selected: _vm.selectedNum == _vm.folders.length },
                    on: { click: _vm.selectAll }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "download-wrapper" }, [
                  _c("i", {
                    staticClass: "icon-download",
                    class: { show: _vm.selectedNum > 0 },
                    on: { click: _vm.downloadImages }
                  })
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "total-item" }, [
              _vm._v(
                _vm._s(_vm.$t("list.total")) +
                  " " +
                  _vm._s(_vm.folders.length) +
                  " " +
                  _vm._s(_vm.$t("list.items"))
              )
            ])
          ]),
          _vm._v(" "),
          _vm._l(_vm.folders, function(folder, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "view-item folder-item",
                class: { selected: folder.selected },
                on: {
                  click: function($event) {
                    return _vm.goShareListDetail(index)
                  }
                }
              },
              [
                _c("div", { staticClass: "wrapper" }, [
                  _c("div", { staticClass: "layer layer-under" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "layer layer-middle" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "layer layer-upper" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "img-wrap" }, [
                    _c("img", {
                      staticClass: "defaul-tag-img",
                      attrs: { src: folder.smallUrl, alt: "" }
                    })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "view-item-t tag-msg" }, [
                    _c("i", { staticClass: "icon-folder" }),
                    _vm._v(" "),
                    _c("span", { staticClass: "tag-title" }, [
                      _vm._v(_vm._s(folder.name))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "checkbox",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.selectedFn(index)
                      }
                    }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tag-mark" })
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _vm.showProcessBar
        ? _c("process-bar", {
            staticStyle: { position: "fixed" },
            attrs: { percentage: _vm.packageProcess, text: _vm.loadingText }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "list-head" }, [
      _c("div", { staticClass: "header-wrap header-public clearfix" }, [
        _c("div", { staticClass: "header-left cleearfix" }, [
          _c("i", { staticClass: "icon-czur-logo" })
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-310a9379", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-310a9379","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notebook/ShareList.vue
// module id = null
// module chunks = 